import { AuthorImage, Container, Name, Twitter } from './styles';

interface AuthorProps {
	name: string;
	handle: string;
}

const Author = ({ name, handle }: AuthorProps) => {
	const ACTON_IMAGE_SRC = '/_n/images/book/watercolor-acton.webp';
	const TEWY_IMG_SRC = '/_n/images/book/watercolor-tewy.webp';
	const imgSrc = handle === 'acton' ? ACTON_IMAGE_SRC : TEWY_IMG_SRC;
	return (
		<Container handle={handle}>
			<AuthorImage alt="" width={310} height={310} src={imgSrc} />
			<Name handle={handle}>{name}</Name>
			<Twitter
				handle={handle}
				className="twitter"
				target="_blank"
				href={`//twitter.com/${handle}`}
				rel="noreferrer"
			>
				{`@${handle}`}
			</Twitter>
		</Container>
	);
};

export default Author;
